// ProductOptionsModal.jsx
import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { getTaxAmount } from "../../methods/commonMethods";
// @ts-ignore
import "../../styles/pos.css";

/**
 *
 * @param {{show: boolean, product: import("../../models/ProductModel").ProductModel | null, onCancel: () => void, onAdd: ({ lineItem }: { lineItem: import("../../models/LineItemModel").LineItemModel; }) => void}} args
 */

export default function ProductOptionsModal({
  show,
  product,
  onCancel,
  onAdd,
}) {
  const [locationList, setLocationList] = useState(
    /** @type {import("../../models/MetaData").MetaData[]} */ ([]),
  );
  const [quantity, setQuantity] = useState(1);
  const [location, setLocation] = useState(
    /** @type {import("../../models/MetaData").MetaData | null} */ (null),
  );
  const [notes, setNotes] = useState("");
  const [accompaniment, setAccompaniment] = useState(
    /**@type {import("../../models/MetaData").MetaData | null} */ (null),
  );
  const [preferences, setPrefences] = useState(
    /**@type {import("../../models/MetaData").MetaData[]} */ ([]),
  );

  // reset local state each time a new product is opened
  useEffect(() => {
    if (show) {
      setQuantity(1);
      setLocation(null);
      setAccompaniment(null);
      setPrefences([]);
      setNotes("");
      /** */
      let availableLocations =
        product?.meta_data.filter((m) => m.key.includes("sba_store")) ?? [];
      setLocationList(availableLocations);
      if (availableLocations.length === 1) {
        if (Number(availableLocations[0].value ?? 0) > 0) {
          setLocation(availableLocations[0]);
        }
      }
    }
  }, [show, product]);

  if (!product) return null;

  const canAdd = Number(location?.value ?? 0) > 0;

  /** @param {{checked : boolean, md: import("../../models/MetaData").MetaData }} args  */
  const handlePref = ({ checked, md }) => {
    if (checked) {
      setPrefences((prev) => [...prev, md]);
    } else {
      setPrefences((prev) => prev.filter((t) => t === md));
    }
  };
  /** @param {{ac:string}}args */
  const handleAccomp = ({ ac }) => {
    let m = {
      id: null,
      key: ac,
      value: "1",
    };
    setAccompaniment(m);
  };

  const handleAdd = () => {
    if (!canAdd) return;

    //   tax and total calculations,

    let totalL = quantity * product.price;
    let vat = getTaxAmount("VAT", product, totalL);
    let catLevy = getTaxAmount("CLEVY", product, totalL);
    let serviceCharge = getTaxAmount("SCHARGE", product, totalL);
    let totalTax = vat + catLevy + serviceCharge;

    // add location, notes, accompaniment to metadta list

    /** @type {import("../../models/MetaData").MetaData[]}  */
    let r = [];

    if (location !== null) {
      r.push(location);
    }

    if (accompaniment !== null) {
      r.push(accompaniment);
    }

    r = [...r, ...preferences];

    if (notes) {
      r.push({ id: null, key: "__sba_pref>>" + notes, value: "1" });
    }

    let li = {
      cat_levy_percent: product.cat_levy_percent,
      product_id: product.id,
      name: product.name,
      // quantity: 1,
      quantity: quantity,
      price: product.price,
      // total: product.price,
      total: totalL,
      total_tax: totalTax,
      sku: product.sku,
      meta_data: r,
      image: null,
      etimitemcd: product.etimitemcd,
      etimitemclscd: product.etimitemclscd,
      etimitemid: product.etimitemid,
      etimsorgnnatcd: product.etimsorgnnatcd,
      etimspkgunitcd: product.etimspkgunitcd,
      etimsqtyunitcd: product.etimsqtyunitcd,
      service_charge_percent: product.service_charge_percent,
      tax_percent: product.tax_percent,
      id: null,
      image_id: null,
      subtotal: totalL - totalTax,
      subtotal_tax: totalTax,
      unit: "pcs",
    };

    // console.log(li);

    onAdd({
      lineItem: li,
    });
  };

  return (
    <Modal show={show} onHide={onCancel} centered contentClassName="pom-modal">
      <div className="pom-title">{product.name.toUpperCase()}</div>

      <div className="pom-label">Quantity</div>
      <div className="pom-stepper">
        <button
          className="pom-step-btn"
          onClick={() => setQuantity((q) => Math.max(1, q - 1))}
        >
          −
        </button>
        <div className="pom-qty-box">{quantity}</div>
        <button
          className="pom-step-btn"
          onClick={() => setQuantity((q) => q + 1)}
        >
          +
        </button>
      </div>

      <div className="pom-label">Order From</div>
      <div className="pom-locations">
        {locationList.map((loc) => (
          <button
            key={loc.id}
            className={`pom-location ${location === loc ? "selected" : ""}`}
            onClick={() => Number(loc.value ?? 0) > 0 && setLocation(loc)}
          >
            <span className="pom-location-name">{loc.key.split(">>")[1]}</span>
            <span
              className={`pom-location-icon ${Number(loc.value ?? 0) > 0 ? "in" : "out"}`}
            >
              {Number(loc.value ?? 0) > 0 ? "✓" : "✕"}
            </span>
            <span
              className={`pom-location-status ${Number(loc.value ?? 0) > 0 ? "in" : "out"}`}
            >
              {Number(loc.value ?? 0) > 0 ? "in stock" : "out of stock"}
            </span>
          </button>
        ))}
      </div>
      {(product?.meta_data.filter((m) => m.key.includes("sba_accomp")) ?? [])
        .length > 0 && (
        <>
          <Form.Select
            aria-label="Accompaniments"
            onChange={(c) => handleAccomp({ ac: c.target.value })}
            required
          >
            <option value={""}>Select Accompaniment</option>
            {(
              product?.meta_data.filter((m) => m.key.includes("sba_accomp")) ??
              []
            ).map((m, i) => (
              <option value={m.key} key={i} disabled={Number(m.value) <= 0}>
                {m.key.split(">>")[1]}
              </option>
            ))}
          </Form.Select>

          <p></p>
        </>
      )}
      {(product?.meta_data.filter((m) => m.key.includes("sba_pref")) ?? [])
        .length > 0 && (
        <>
          <div className="pom-label">Preference</div>
          <Row>
            {(
              product?.meta_data.filter((m) => m.key.includes("sba_pref")) ?? []
            ).map((m) => (
              <Col xl={3} md={4} sm={4}>
                {" "}
                <Form.Check
                  label={m.key.split(">>")[1]}
                  checked={preferences.includes(m)}
                  onChange={(e) =>
                    handlePref({ checked: e.target.checked, md: m })
                  }
                />{" "}
              </Col>
            ))}
          </Row>

          <p></p>
        </>
      )}
      <div className="pom-label">Notes</div>
      <Form.Control
        as="textarea"
        rows={2}
        className="pom-notes"
        placeholder="e.g. no ice, extra glass..."
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
      />

      <div className="pom-footer">
        <button className="pom-cancel" onClick={onCancel}>
          Cancel
        </button>
        <button className="pom-add" onClick={handleAdd} disabled={!canAdd}>
          ADD
        </button>
      </div>
    </Modal>
  );
}
